import { css } from 'emotion'

export const UpdatePasswordFormStyles = css``
